import { useTranslation } from "react-i18next";
import plus from "../resources/img/plus.svg";
import arrow_down from "../resources/img/arrow_down.svg";
import copy_icon from "../resources/img/copy_icon.png";
import edit_icon from "../resources/img/edit_icon.svg";
import { CardInfo, OperatorInfo, OperatorRole } from "../Utils/BackendInterface";
import { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";
import {
  SortType,
  ListColumn,
  copyToClipboard,
  setRowCheckboxState,
  showInfoNotification,
  sortSubject,
} from "../Utils/utils";
import { Subscription } from "rxjs";

export const GeneralManagementList = (props: {
  columns: ListColumn[];
  rowValues: any[]; // should be an array of objects with properties at max depth 1
  selectBoxIdKey: string;
  setAddRowView: (show: boolean) => void;
  setEditRowView?: (showState: any) => void; // to show the edit view, usually passes the edit values
  hasTitleSelectCheckBox?: boolean;
  hasRowSelectCheckBoxes?: boolean;
}) => {
  return (
    <div className="w-11/12 min-h-10rem mt-7 bg-white flex flex-col justify-start items-center">
      <GenericTitleRow
        // hasSelectCheckbox={(props.rowValues as OperatorInfo[])?.[0]?.role ? true : false}
        hasSelectCheckbox={props.hasTitleSelectCheckBox}
        columns={props.columns}
      />

      {props.rowValues.map((e, i) => (
        <ListEntryRow
          key={`listEntryRowValue_${i}`}
          setEditRowView={props.setEditRowView}
          listEntryValues={e}
          columns={props.columns}
          hasSelectBox={props.hasRowSelectCheckBoxes}
          selectBoxIdKey={props.selectBoxIdKey}
        />
      ))}

      <AddEntryRow setShowAddView={props.setAddRowView} />
    </div>
  );
};

/**
 * Component parts for the general user list, currently uses unclean work-around *if's* for handling different entry types of a user list,
 * like a link (for copying the nfclink) and so on, should ideally be refactored to handle generic entries better
 * @param props
 * @returns
 */
export const GenericTitleRow = (props: { columns: ListColumn[]; hasSelectCheckbox?: boolean }) => {
  return (
    <div
      id="titleRow"
      className="w-full min-h-rowEntry flex flex-row justify-start items-center mt-3"
    >
      {/* first the 2 boxes */}
      {props.hasSelectCheckbox && <CheckBoxColumnTitle isCheckBox />}
      <CheckBoxColumnTitle />

      {props.columns.map((e, i) => {
        if (e.labelKey === "nfcLink") {
          return (
            <div
              key={`title_nfcLink_entry_${i}`}
              className={`min-w-square-check h-full ${
                i !== props.columns.length - 1 ? "border-r-custom border-r-black" : ""
              } border-b-custom border-b-black flex flex-row justify-center items-center`}
            >
              {/* maybe shouldn't be empty but idk */}
            </div>
          );
        }
        return (
          <GeneralColumnTitle
            key={`genericColumnTitle_${i}`}
            column={e}
            isLast={i === props.columns.length - 1}
          />
        );
      })}
    </div>
  );
};

export const ListEntryRow = (props: {
  listEntryValues: any;
  columns: ListColumn[];
  selectBoxIdKey: string; // used for find ing the checkbox through queries
  setEditRowView?: (state: any) => void;
  hasSelectBox?: boolean;
}) => {
  const [t, i18n] = useTranslation();
  return (
    <div className="w-full min-h-rowEntry flex flex-row justify-start items-center ">
      {/* {(props.userEntryValues as OperatorInfo).role === undefined && ( */}
      {props.hasSelectBox && (
        <CheckBoxEditColumnEntry
          isCheckBox
          rowValues={props.listEntryValues}
          selectBoxRowValueKey={props.selectBoxIdKey}
        />
      )}
      <CheckBoxEditColumnEntry
        isEditBox
        setEditRowView={props.setEditRowView}
        rowValues={props.listEntryValues}
        selectBoxRowValueKey={props.selectBoxIdKey}
      />

      {props.listEntryValues && (
        <>
          {props.columns.map((e, i) => {
            if ((props.listEntryValues as any)[e.labelKey] !== undefined) {
              if (e.labelKey === "nfcLink") {
                // example dirty workaround to handle copying the nfc link, TODO: refactor to let overall list handle different entries better
                return (
                  <div
                    key={`title_nfcLink_entry_${i}`}
                    className={`w-square-check min-w-square-check h-full ${
                      i !== props.columns.length - 1 ? "border-r-custom border-r-black" : ""
                    } border-b-custom border-b-black flex flex-row justify-center items-center `}
                  >
                    <img
                      src={copy_icon}
                      className="cursor-pointer w-4/5"
                      title={t("copy-nfc-link")}
                      onClick={() => {
                        if ((props.listEntryValues as CardInfo).nfcLink) {
                          copyToClipboard(
                            (props.listEntryValues as CardInfo).nfcLink!,
                            "info-copied-nfclink"
                          );
                        }
                      }}
                    />
                  </div>
                );
              }
              return (
                <div
                  key={`title_other_entry_${i}`}
                  className={`w-customLabelEntry min-w-customLabelEntry max-w-customLabelEntry h-full ${
                    i !== props.columns.length - 1 ? "border-r-custom border-r-black" : ""
                  } border-b-custom border-b-black flex flex-row justify-between items-center text-sm`}
                >
                  <span className="h-fit ml-0 p-1 overflow-hidden whitespace-nowrap overflow-ellipsis max-w-customLabelEntry">
                    {e.labelKey === "idLayout"
                      ? (props.listEntryValues as CardInfo).layoutDisplayName ?? "?"
                      : e.labelKey === "idArea"
                      ? (props.listEntryValues as CardInfo).areaDisplayName ?? "?"
                      : (props.listEntryValues as any)[e.labelKey]}
                  </span>
                </div>
              );
            }
          })}
        </>
      )}
    </div>
  );
};

// util helper component functions ---------------------------

const AddEntryRow = (props: { setShowAddView: (state: boolean) => void }) => {
  return (
    <div className="w-full min-h-rowEntry flex flex-row justify-start items-center ">
      <div className="min-w-square-check h-full flex flex-col justify-center items-center">
        <img
          src={plus}
          className="w-add-button cursor-pointer p-1"
          onClick={() => props.setShowAddView(true)}
        ></img>
      </div>
    </div>
  );
};

const CheckBoxColumnTitle = (props: { isCheckBox?: boolean }) => {
  return (
    <div
      key={`titleCheckBox_${props.isCheckBox ? 1 : 0}`}
      className="min-w-square-check h-full border-r-custom border-r-black border-b-custom border-b-black flex flex-col justify-center items-center"
    >
      {props.isCheckBox ? (
        <input
          type="checkbox"
          className="min-w-checkmin min-h-checkmin"
          onChange={(e) => {
            setRowCheckboxState(e.target.checked);
          }}
        ></input>
      ) : (
        <></>
      )}
    </div>
  );
};
const CheckBoxEditColumnEntry = (props: {
  isCheckBox?: boolean;
  isEditBox?: boolean;
  setEditRowView?: (state: any) => void;
  rowValues: any; // should be an object, with values at max depth 1
  selectBoxRowValueKey: string; // used for labelling the select boxes, so it can be found later again
}) => {
  const [operatorEmail, setOperatorEmail] = useState("");
  const outletInfo = useOutletContext<{ currentUser: OperatorInfo }>();

  useEffect(() => {
    if ((props.rowValues as OperatorInfo).role) {
      setOperatorEmail(props.rowValues.email);
    }
  }, []);

  return (
    <div className="min-w-square-check h-full border-r-custom border-r-black border-b-custom border-b-black flex flex-col justify-center items-center">
      {props.isEditBox &&
      (!(props.rowValues as OperatorInfo).role || // user entry is a card user = always show the edit
        outletInfo.currentUser.role === OperatorRole.ADMIN ||
        (outletInfo.currentUser.role === OperatorRole.MANAGER &&
          (props.rowValues as OperatorInfo).role === OperatorRole.MANAGER)) ? (
        <img
          src={edit_icon}
          className="w-full cursor-pointer"
          onClick={() => {
            if (props.setEditRowView) props.setEditRowView(props.rowValues!);
          }}
        />
      ) : props.isCheckBox ? (
        <input
          id={`checkbox_${props.rowValues[props.selectBoxRowValueKey]}`}
          // id={`checkbox_${
          //   operatorEmail
          //     ? "operator_" + props.rowValues.email
          //     : "user_" + (props.rowValues as CardInfo).nfcId
          // }`}
          type="checkbox"
          className="min-w-checkmin min-h-checkmin"
        ></input>
      ) : (
        <></>
      )}
    </div>
  );
};

const GeneralColumnTitle = (props: { column: ListColumn; isLast?: boolean }) => {
  const [t, i18n] = useTranslation();
  const [sortType, setSortType] = useState<SortType>(SortType.NONE);

  // useEffect(() => {
  //   // for notifying other columns that they should remove their sorting activated button
  //   if (sortType !== SortType.NONE)
  //     sortSubject.next({ type: sortType, columnLabel: props.column.labelKey });
  // }, [sortType]);

  useEffect(() => {
    let sortSub: Subscription;
    if (props.column.hasSorting) {
      sortSub = sortSubject.subscribe((sorting) => {
        if (sorting.columnLabel !== props.column.labelKey) {
          // if the receiving sort setting isn't its own, set to none
          setSortType(SortType.NONE);
        } else {
          // receiving sort type is from itself, so no need to do anything here
        }
      });
    }

    return function cleanup() {
      sortSub?.unsubscribe();
    };
  }, []);

  const handleClickedSortButton = () => {
    switch (sortType) {
      case SortType.NONE:
        setSortType(SortType.ALPHABET);
        sortSubject.next({ type: SortType.ALPHABET, columnLabel: props.column.labelKey });
        break;

      case SortType.ALPHABET:
        setSortType(SortType.ALPHABET_REVERSE);
        sortSubject.next({ type: SortType.ALPHABET_REVERSE, columnLabel: props.column.labelKey });
        break;

      case SortType.ALPHABET_REVERSE:
        setSortType(SortType.NONE);
        sortSubject.next({ type: SortType.NONE, columnLabel: props.column.labelKey });
        break;
    }
  };

  return (
    <div
      key={`titleEntry_${props.column.labelKey}`}
      className={`min-w-customLabelEntry max-w-customLabelEntry h-full border-b-custom border-b-black flex flex-row justify-between items-center font-semibold ${
        props.isLast ? "" : "border-r-custom border-r-black"
      }`}
    >
      {props.column.hasSorting && (
        <>
          <span className="h-fit ml-2 p-1">{t(props.column.labelKey)}</span>
          <img
            className={`w-1em mr-2 cursor-pointer ${
              sortType === SortType.ALPHABET
                ? "brightness-50"
                : sortType === SortType.ALPHABET_REVERSE
                ? "brightness-50 rotate-180"
                : ""
            }`}
            src={arrow_down}
            onClick={() => {
              handleClickedSortButton();
            }}
          />
        </>
      )}

      {!props.column.hasSorting && (
        <span className="h-fit ml-2 p-1">{t(props.column.labelKey)}</span>
      )}
    </div>
  );
};
